// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
} from '@angular/core';
import { TippyDirective } from '@ngneat/helipopper';

@Component({
  selector: 'tippy-tooltip',
  standalone: true,
  template: `
    <ng-template #tooltipContent>
      <div class="html-content" [innerHTML]="content()"></div>
    </ng-template>

    <sh-icon
      [tp]="tooltipContent"
      tpPlacement="bottom"
      tpAnimation="scale"
      tpInteractive="true"
      icon="information"
      size="m"
    >
    </sh-icon>
  `,
  styleUrl: './tippy-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TippyDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TippyTooltipComponent {
  content = input.required<string>();
}
